/**
 * Loading
 *
 * Simple spinner with size options; used inside modals and buttons.
 */
import React from 'react';

export function Loading({ className = "", size = "default" }) {
  const sizeClasses = 
    size === "small" ? "h-4 w-4" :
    size === "large" ? "h-8 w-8" :
    "h-6 w-6";

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div 
        className={`animate-spin rounded-full ${sizeClasses} border-b-2 border-primary-500 dark:border-primary-400`}
      ></div>
    </div>
  );
} 